<cipo-dialog-header
    testId="module-config-annotation-dialog-header"
    closeTestId="module-config-annotation-action-close"
    fullScreen="never"
    [title]="isEdit ? 'modules.screenDesigner.editAnnotation' : 'modules.screenDesigner.addAnnotation'"
    [customCloseMode]="true"
    (closeClick)="tryClose()" />

<mat-dialog-content>
    <div class="p-y" fxLayout="column" fxLayoutGap="4px" data-testid="module-config-annotation-dialog-editor">
        <app-froala [froalaoptions]="froalaOptions" [content]="content()" (contentChange)="content.set($event)" />
        @if (submitted() && !content()) {
            <span
                class="mat-caption cipo-text--warn-900"
                role="alert"
                data-testid="module-config-annotation-dialog-required">
                {{ "errors.required" | translate }}
            </span>
        }
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end" [class.cipo-bg--warn-400]="warningContext()">
    @if (warningContext()) {
        <span class="m-r-sm">{{ "general.discardMessage" | translate }}</span>
        <button mat-stroked-button (click)="dismissWarning()">{{ "actions.cancel" | translate }}</button>
        <button
            mat-stroked-button
            color="warn"
            data-testid="module-config-annotation-action-discard"
            (click)="discardAndClose()">
            {{ "actions.discard" | translate }}
        </button>
        <button mat-flat-button color="primary" data-testid="module-config-annotation-action-save" (click)="save()">
            {{ (isEdit ? "actions.update" : "general.add") | translate }}
        </button>
    } @else {
        <button mat-button data-testid="module-config-annotation-action-cancel" (click)="tryClose()">
            {{ "actions.cancel" | translate }}
        </button>
        <button mat-flat-button color="primary" data-testid="module-config-annotation-action-save" (click)="save()">
            {{ (isEdit ? "actions.update" : "general.add") | translate }}
        </button>
    }
</mat-dialog-actions>
